// extracted by mini-css-extract-plugin
module.exports = {"loading":"Standard_loading__3TcuR","show":"Standard_show__2SUY-","hide":"Standard_hide__ctTlH","animation":"Standard_animation__Ob3DC","Spinner":"Standard_Spinner__3e4je"};